module.exports = __webpack_public_path__ + "static/social-preview-0b132c8aa0a5dd3b7f846f06242e24b3.jpg";